import { ContentSaveAllOutlineIcon } from './ContentSaveAllOutlineIcon';

/**
 * author: Michael Irigoyen
 * id B65ADBE9-DE1B-4879-A34F-602A3DA4D12A
 * name content-save-all-outline
 * version: 3.9.97
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/content-save-all-outline.svg
 * tags
 */
export const FloppyDiscMultipleOutlineIcon = ContentSaveAllOutlineIcon;
export default FloppyDiscMultipleOutlineIcon